import React from 'react'
import PropTypes from 'prop-types'

export default class SentryBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo)
      Sentry.captureException(error)
    })
  }

  render() {
    return this.props.children
  }
}
